module.exports = __webpack_public_path__ + "static/img/zhizhongxin .213da2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhizhongxin .png
// module id = cJl7
// module chunks = 1